import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';
import { UpdateReceiptComponent } from '../update-receipt/update-receipt.component';
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}
@Component({
    selector: 'app-view-receipts',
    templateUrl: './view-receipts.component.html',
    styleUrls: ['./view-receipts.component.scss'],
})
export class ViewReceiptsComponent implements OnInit {
    maxDate: Date = new Date();
    Date: Date = new Date();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective, { static: false })
    private datatableElement: DataTableDirective;
    dtTrigger = new Subject<any>();
    SelectedDate: any;
    param: any;
    userID: any;
    planId: any;
    pdfUrl: any;
    breadCrumbItems: (
        | { label: string; path: string; active?: undefined }
        | { label: string; path: string; active: boolean }
    )[];
    user: any;
    baseURL: string;
    isLoading: boolean;
    ReceiptType: any;
    /** Land Record orders (tblUserAdhocDelivery) of this user, keyed by AdhocDeliveryID */
    landRecordOrders: any[] = [];
    private ordersById: { [id: string]: any } = {};

    constructor(
        private activatedRoute: ActivatedRoute,
        public dialog: MatDialog,
        private http: HttpClient,
        private gs: GeneralService,
        private toastr: ToastrService,
        private datepipe: DatePipe,
        private router: Router,
        @Inject(LOCALE_ID) public locale: string
    ) {
        this.loadUserAndPlanIds();
        if (this.router.getCurrentNavigation()) {
            if (this.router.getCurrentNavigation().extras.state) {
                const state = this.router.getCurrentNavigation().extras.state;
                this.userID = state['UserId'];
                this.planId = state['PlanId'];

                console.log(state, 'state Recpit');
                localStorage.setItem('UserId', this.userID);
                localStorage.setItem('PlanId', this.planId);
            } else {
                if (localStorage.getItem('UserId')) {
                    this.userID = localStorage.getItem('UserId');
                }
            }
        }
    }

    private loadUserAndPlanIds(): void {
        const nav = this.router.getCurrentNavigation();
        let state;

        if (nav && nav.extras && nav.extras.state) {
            state = nav.extras.state;
        }

        if (state && state.UserId && state.PlanId) {
            this.userID = state.UserId;
            this.planId = state.PlanId;
            localStorage.setItem('UserId', this.userID);
            localStorage.setItem('PlanId', this.planId);
            console.log('Loaded from router state:', this.userID, this.planId);
        } else {
            // Fallback to localStorage
            this.userID = localStorage.getItem('UserId');
            this.planId = localStorage.getItem('PlanId');
            console.log('Loaded from localStorage:', this.userID, this.planId);
        }
    }

    ngOnInit(): void {
        this.userID = this.userID || localStorage.getItem('UserId');
        this.planId = this.planId || localStorage.getItem('PlanId');

        if (!this.userID || !this.planId) {
            this.toastr.error('User ID or Plan ID is missing!');
            this.router.navigate(['/users']); // Redirect to safe route
            return;
        }
        this.baseURL = this.gs.getBaseurl();
        this.gs.getReceiptType().subscribe(
            (Response: any) => {
                this.ReceiptType = Response.result;
            },
            (error) => {
                //Error callback
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                });
                //throw error;   //You can also throw the error to a global error handler
            }
        );
        // this.userID = this.activatedRoute.snapshot.params.Id;
        this.breadCrumbItems = [
            { label: 'User List', path: '/users/users-users/'},
            { label: 'User Details', path: '/users/users-users-details' },
            {
                label: 'Receipts',
                path: '/users/users-users-details/receipts',
                active: true,
            },
        ];
        this.SelectedDate = this.datepipe.transform(this.Date, 'yyyy-MM-dd');
        var d = new Date(this.SelectedDate);
        this.getusersbyid();
        this.dtOptions = {
            ajax: (dataTablesParameters: any, callback) => {
                /* Receipts (existing flow) + Land Record orders (tblUserAdhocDelivery).
                   The orders call is best-effort: if it fails the grid still shows
                   the receipts exactly as before. */
                const receipts$ = this.http.get<DataTablesResponse>(
                    `${this.gs.GETUserReceipts()}/${this.userID}`,
                    {}
                );
                const orders$ = this.gs.getLandRecordOrders(this.userID).pipe(
                    catchError((err) => {
                        console.error('Land Record orders could not be loaded', err);
                        return of({ data: [] });
                    })
                );

                forkJoin([receipts$, orders$]).subscribe(
                    ([receiptResp, orderResp]: any[]) => {
                        callback({
                            data: this.buildGridRows(
                                (receiptResp && receiptResp.data) || [],
                                (orderResp && orderResp.data) || []
                            ),
                        });
                    },
                    (error) => {
                        Swal.fire({
                            title: error.status,
                            text: 'Internal Server Error',
                            type: 'error',
                        });
                        callback({ data: [] });
                    }
                );
            },
            columns: [
                {
                    title: 'Sr.No.',
                    data: null,
                    render: (data, type, row, meta) => {
                        return meta.row + 1;
                    },
                },
                {
                    title: 'Receipt Type',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return `Land Record <span class="badge badge-warning p-1" title="Order placed on jahernotice.com — receipt not generated yet">Order</span>`;
                        }
                        return `${
                            data.receiptTypeName != '' && data.receiptTypeName != null
                                ? data.receiptTypeName
                                : 'N/A'
                        }`;
                    },
                },
                {
                    title: 'Receipt No.',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return `<span class="badge badge-secondary p-1" title="Click Generate Receipt to create the receipt for this order">Not Generated</span>`;
                        }
                        return `<div style="display:flex">
            <a class="btn text-primary plus" href="${this.baseURL}${data.pdf_path}" target="_blank" title="View Receipt">
            ${data.recieptNumber}</a>`;
                    },
                },
                {
                    title: 'Date',
                    data: null,
                    render: (data, type, row, meta) => {
                        return data.rowType === 'order'
                            ? this.formatOrderDate(this.orderDate(data))
                            : this.formatGridDate(data.recieptDate);
                    },
                },
                {
                    /* Order rows (no receipt yet): the order date is shown for Start and
                       End as well — a Land Record receipt uses the same day for all three.
                       Once the receipt is generated the row shows the real stored dates. */
                    title: 'Start Date',
                    data: null,
                    render: (data, type, row, meta) => {
                        return data.rowType === 'order'
                            ? this.formatOrderDate(this.orderDate(data))
                            : this.formatGridDate(data.startDate);
                    },
                },
                {
                    title: 'End Date',
                    data: null,
                    render: (data, type, row, meta) => {
                        return data.rowType === 'order'
                            ? this.formatOrderDate(this.orderDate(data))
                            : this.formatGridDate(data.endDate);
                    },
                },
                {
                    title: 'Quotation',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return '--';
                        }
                        return `<div style="display:flex"><a class="btn text-primary plus" href="${this.baseURL}${data.pdfPath}" target="_blank" title="View Quotation">
            <span class="badge badge-success p-1">View</span></a>`;
                    },
                },
                {
                    title: 'Invoice',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return '--';
                        }
                        return `<a class="pdf text-primary pdf" title="View Invoice" href="${this.baseURL}${data.invoice_pdf_path}" target="_blank">
            <i style='color:red' class="btn font-18 mdi mdi-file-pdf-box text-secondary" ></i></a>`;
                    },
                },
                {
                    /* Receipt rows: payment mode (cash / razorpay / ...).
                       Order rows: Paid / Unpaid status badge. */
                    title: 'Payment',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            /* Only this badge is centred; the rest of the grid keeps its default alignment */
                            return data.isPaid
                                ? `<div class="text-center"><span class="badge badge-success p-1" title="Paid via ${data.payment_type || 'Online'}${data.TransactionID ? ' (Txn ' + data.TransactionID + ')' : ''}">Paid</span></div>`
                                : `<div class="text-center"><span class="badge badge-danger p-1" title="No payment / transaction recorded on the order">Unpaid</span></div>`;
                        }
                        return data.payment_mode;
                    },
                },
                {
                    title: 'Amount',
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return data.total_price != null ? data.total_price : 'N/A';
                        }
                        return data.amount;
                    },
                },
                {
                    title: 'Action',
                    orderable: false,
                    data: null,
                    render: (data, type, row, meta) => {
                        if (data.rowType === 'order') {
                            return `<div style="display:flex">
            <button type="button" class="btn btn-sm btn-success generate-receipt" style="white-space:nowrap"
              title="Open Add Receipt prefilled from this Land Record order" AdhocDeliveryId="${data.AdhocDeliveryID}">
              Generate Receipt</button></div>`;
                        }
                        return `<div style="display:flex">
            <a title="Edit This Service" class="edit">
              <i class="btn font-18 mdi mdi-content-save-edit-outline text-secondary" UserId="${data.id}"></i>
            </a>`;
                    },
                },
                {
                    title: 'View More',
                    className: 'details-control',
                    orderable: false,
                    data: null,
                    defaultContent: `<div style="display:flex">
                            <a class="" title="View More">
                            <i class="btn font-18 mdi mdi-eye-outline text-secondary"></i></a>`,
                },
            ],
            drawCallback: () => {
                $('.edit').off('click').on('click', (e) => {
                    const id =
                        e.target.getAttribute('UserId') ||
                        $(e.currentTarget).find('i').attr('UserId');
                    this.openDialog(id);
                });
                $('.generate-receipt').off('click').on('click', (e) => {
                    const id =
                        e.currentTarget.getAttribute('AdhocDeliveryId') ||
                        e.target.getAttribute('AdhocDeliveryId');
                    this.generateReceipt(id);
                });
            },
        };
    }

    /** dd-MM-yyyy, or N/A when empty. */
    private formatGridDate(value: any): string {
        if (value == '' || value == null) {
            return 'N/A';
        }
        return this.datepipe.transform(new Date(value), 'dd-MM-yyyy');
    }

    /** dd-MM-yyyy of a Land Record order date, exactly as stored. MSSQL datetimes are
        stored in IST but the API sends them with a 'Z' (UTC) suffix, so format in UTC
        instead of letting the browser shift them +5:30 (22:54 on the 26th → 27th). */
    private formatOrderDate(value: any): string {
        if (value == '' || value == null) {
            return 'N/A';
        }
        return this.datepipe.transform(new Date(value), 'dd-MM-yyyy', 'UTC');
    }

    /** Order date shown in the grid: the Order Record Date (fallbacks only when NULL). */
    private orderDate(order: any) {
        return order.Order_Record_date || order.OrderDate || order.Order_date || null;
    }

    /**
     * Merges receipts and Land Record orders into one grid data set:
     *  - orders WITHOUT a receipt come first (rowType 'order', Generate Receipt),
     *  - receipts keep their existing shape (rowType 'receipt') and get the linked
     *    order attached (Order ID column / View More) when payment_reciept.AdhocDeliveryID is set.
     */
    private buildGridRows(receipts: any[], orders: any[]): any[] {
        this.landRecordOrders = orders || [];
        this.ordersById = {};
        this.landRecordOrders.forEach((o) => {
            this.ordersById[String(o.AdhocDeliveryID)] = o;
        });

        const receiptRows = (receipts || []).map((r) => {
            const linked =
                r.AdhocDeliveryID != null ? this.ordersById[String(r.AdhocDeliveryID)] : null;
            return Object.assign({}, r, {
                rowType: 'receipt',
                orderNo: r.orderNo || (linked ? linked.Order_ID : null),
                linkedOrder: linked || null,
            });
        });

        const linkedOrderIds: { [id: string]: boolean } = {};
        receiptRows.forEach((r) => {
            if (r.AdhocDeliveryID != null) {
                linkedOrderIds[String(r.AdhocDeliveryID)] = true;
            }
        });

        const pendingOrderRows = this.landRecordOrders
            .filter((o) => !o.hasReceipt && !linkedOrderIds[String(o.AdhocDeliveryID)])
            .map((o) => Object.assign({}, o, { rowType: 'order' }));

        return pendingOrderRows.concat(receiptRows);
    }

    /** "Generate Receipt" on a pending Land Record order → Add Receipt, prefilled. */
    generateReceipt(adhocDeliveryId) {
        if (!adhocDeliveryId) {
            this.toastr.error('Land Record order id is missing!');
            return;
        }
        localStorage.setItem('UserId', this.userID);
        if (this.planId) {
            localStorage.setItem('PlanId', this.planId);
        }
        localStorage.setItem('AdhocDeliveryID', String(adhocDeliveryId));
        /* Started from this user's receipts → come back here after saving. */
        localStorage.removeItem('ReceiptReturnTo');
        this.router.navigate(['users/users-users-details/receipts/add'], {
            state: {
                UserId: this.userID,
                PlanId: this.planId,
                AdhocDeliveryID: String(adhocDeliveryId),
            },
        });
    }
    ngAfterViewInit() {
        this.dtTrigger.next();
        const self = this;
        if (this.datatableElement) {
            this.datatableElement.dtInstance.then((table) => {
                // Add event listener for opening and closing details
                $('table tbody').on('click', 'td.details-control', function () {
                    var tr = $(this).closest('tr');
                    var row = table.row(tr);

                    if (row.child.isShown()) {
                        // This row is already open - close it
                        row.child.hide();
                        tr.removeClass('shown');
                    } else {
                        // Open this row
                        row.child(self.format(row.data())).show();
                        tr.addClass('shown');
                    }
                });
            });
        }
    }

    /** True when a value is worth showing (not empty and not a stored placeholder). */
    private hasValue(v: any): boolean {
        if (v === null || v === undefined) {
            return false;
        }
        const s = String(v).trim();
        return (
            s !== '' &&
            ['N/A', 'NA', '--', '-', 'NULL', 'UNDEFINED', '0000-00-00'].indexOf(
                s.toUpperCase()
            ) === -1
        );
    }

    /** Builds the View More table from [label, value] pairs, skipping rows without a value. */
    private detailsTable(rows: [string, any][]): string {
        const body = rows
            .filter(([, value]) => this.hasValue(value))
            .map(([label, value]) => `<tr><td>${label}:</td><td>${value}</td></tr>`)
            .join('');
        return `<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">${body}</table>`;
    }

    private detailsDate(v: any): string {
        return this.hasValue(v)
            ? this.datepipe.transform(new Date(v), 'dd-MM-yyyy')
            : null;
    }

    /** View More for a pending Land Record order row. */
    private formatOrder(o) {
        const location = [o.VillageName, o.TalukaName, o.DistrictName]
            .filter((x) => this.hasValue(x))
            .join(', ');
        return this.detailsTable([
            ['Order ID', o.Order_ID],
            ['Order Date', this.hasValue(this.orderDate(o)) ? this.formatOrderDate(this.orderDate(o)) : null],
            ['Services Ordered', o.services],
            ['Village / Taluka / District', location],
            ['Survey No.', o.Survey_No],
            ['Payment Type', o.isPaid ? o.payment_type || 'Online' : 'Unpaid'],
            ['Transaction ID', o.TransactionID],
            ['Order Amount', o.total_price],
            ['Bill to Name', o.BillTo],
            ['Billing Address', o.BillingAddress],
            ['GST No.', o.CustomerGST],
            ['Source', o.Source],
        ]);
    }

    format(d) {
        // `d` is the original data object for the row
        if (d.rowType === 'order') {
            return this.formatOrder(d);
        }
        const linked = d.linkedOrder;
        return this.detailsTable([
            ['Land Record Order', d.orderNo],
            ['Services Ordered', linked ? linked.services : null],
            ['Bill to Name', d.billTo],
            ['Address', d.billToAddress],
            ['GST No.', d.gst_no],
            ['Package', d.plan_name],
            ['Message', d.message],
            ['Transaction ID', d.transaction_id],
            ['Receipt Type', d.receiptTypeName],
            ['Cheque No.', d.chequeNumber],
            ['Cheque Date', this.detailsDate(d.chequeDate)],
            ['Bank Name', d.bankName],
            ['Bank Account Number', d.bankAccountNumber],
            ['Branch Name', d.branchName],
        ]);
    }
    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    getusersbyid() {
        this.isLoading = true;
        this.gs.getusersbyid(this.userID).subscribe(
            (res: any) => {
                this.isLoading = false;
                this.user = res.data[0];
                this.user.mobileno = this.user.MobileNo.split(',');
                this.user.email = this.user.EmailID.split(',');
                localStorage.setItem('PlanId', this.user.plan_id);
            },
            (error) => {
                //Error callback
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                });
                //throw error;   //You can also throw the error to a global error handler
            }
        );
    }
    openDialog(receiptid): void {
        const dialogRef = this.dialog.open(UpdateReceiptComponent, {
            width: '600px',
            data: { UserId: this.userID, ReceiptId: receiptid },
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: false,
        });

        dialogRef.afterClosed().subscribe((result) => {
            console.log('The dialog was closed');
        });
    }

    viewReceipt() {
        /* Plain "Add Receipt" — make sure no stale Land Record order prefill leaks in. */
        localStorage.removeItem('AdhocDeliveryID');
        localStorage.removeItem('ReceiptReturnTo');
        this.router.navigate(['users/users-users-details/receipts/add']);
    }
}
